import { useEffect, useMemo } from 'react';
import { useAbilityContext } from '../../../../../../Can/Can';
import { Action } from '../../../../../../../enums/action';
import { PAGE_TITLE, PAGE_TITLE_COMPONENT } from '../../../../../../../constants/common';
import { ChartPreference } from '../../../../../../../store/models/chart-preference';
import { useAppDispatch, useAppSelector } from '../../../../../../../store/store';

export interface IChartPreferencesInteractor {
  settings: ChartPreference | null;
  canEdit: boolean;
}

export interface ChartPreferencesInteractorProps {
  cycleId: string;
}

export const useChartPreferencesInteractor = (props: ChartPreferencesInteractorProps): IChartPreferencesInteractor => {
  const { cycleId } = props;
  const ability = useAbilityContext();

  const canUpdatePreferences = useMemo(() => {
    return ability.can(Action.Update, PAGE_TITLE_COMPONENT[PAGE_TITLE.CYCLE].CHART_PREFERENCES);
  }, [ability]);

  const chartPreference: ChartPreference | null = useAppSelector((state) => state.chart_preference.chartPreference);

  const {
    chart_preference: { getOneByCycleId },
  } = useAppDispatch();

  useEffect(() => {
    if (cycleId) {
      getOneByCycleId(cycleId);
    }
  }, [cycleId]);

  return {
    settings: chartPreference,
    canEdit: canUpdatePreferences,
  };
};
